<template>
  <div>
    <v-select
      v-model="selected"
      :items="properties"
      item-value="id"
      item-text="name"
      label="Select Landlord"
      :return-object="true"
      @change="emitProperty"
      clearable
      outlined
      dense
      hide-details
      prepend-inner-icon="mdi-magnify"
      class="landlord-select"
      :menu-props="{ closeOnContentClick: false }"
      :search-input.sync="search"
    >
      <!-- Selection Slot -->
      <template v-slot:selection="{ item }">
        <div class="d-flex flex-column py-1" v-if="item">
          <strong class="text-body-2">{{ item.name }}</strong>
          <span class="text-caption grey--text text--darken-1">{{ item.displayAs || 'No display name' }}</span>
        </div>
      </template>

      <!-- Item Slot (in dropdown) -->
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-on="on" v-bind="attrs" class="pl-3">
          <v-list-item-content>
            <v-list-item-title>
              <strong>{{ item.name }}</strong>
            </v-list-item-title>
            <v-list-item-subtitle class="grey--text">
              {{ item.displayAs || 'No display name' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <!-- Optional: No data message -->
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            No landlords found
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    properties: {
      type: Array,
      required: true
    },
    selectedProperty: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selected: this.selectedProperty || null,
      search: '' // Required for search functionality
    };
  },
  watch: {
    selectedProperty(val) {
      this.selected = val;
    }
  },
  methods: {
    emitProperty() {
      this.$emit('property-selected', this.selected);
    }
  }
};
</script>

<style scoped>
.landlord-select {
  max-width: 100%;
}

/* Make the dropdown wider and more readable */
::v-deep .v-list-item {
  min-height: 56px !important;
}

/* Optional: Highlight search matches */
::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  white-space: normal;
  word-break: break-word;
}
</style>